import * as React from "react";
import {
  CalendarHeartFill,
  CircleFill,
  GeoAltFill,
} from "react-bootstrap-icons";
import Badge from "react-bootstrap/Badge";
import Col from "react-bootstrap/Col";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import classNames from "classnames";

import { PageSpinner, formatDate, useApi } from "../util";
import AddToCalendarButton from "../components/AddToCalendarButton";
import { AppInvite } from "../types";
import { AuthContext } from "../context";
import EventDescription from "../components/EventDescription";

import "../styles/schedule.css";

const Schedule = () => {
  const [loading, setLoading] = React.useState(true);
  const [invites, setInvites] = React.useState<Array<AppInvite>>();

  const { fetch } = React.useContext(AuthContext);
  const api = useApi(fetch!);

  React.useEffect(() => {
    void (async () => {
      const invites = await api.getInvites();
      invites.sort((a, b) => a.event.start_date - b.event.start_date);
      setInvites(invites);

      setLoading(false);
    })();
  }, [api]);

  if (loading || !invites) {
    return <PageSpinner />;
  }

  return (
    <div className="schedule text-light">
      <Helmet>
        <title>Schedule</title>
      </Helmet>
      {invites.map((invite, i) => (
        <Row key={invite.event.slug}>
          <Col
            className="d-flex justify-content-center timeline-icon-container"
            md={{ span: 1, offset: 3 }}
            xs={1}
          >
            <div className="icons-container position-relative mt-sm-0 mt-1">
              <CircleFill
                className="position-absolute top-0 start-50 mt-1 fs-3 d-print-none"
                fill="#57202d"
              />
              <CalendarHeartFill
                className="position-absolute top-0 start-50 mt-1 fs-3"
                fill="#dae0e6"
              />
            </div>
          </Col>
          <Col
            className={classNames({ "pb-3": i !== invites.length - 1 })}
            md={5}
            xs={11}
          >
            <div className="d-flex flex-row justify-content-between align-items-center">
              <h5 className="event-title d-inline-block" id={invite.event.slug}>
                {invite.event.name}
              </h5>
              {invite.responses.some(({ attending }) => attending == null) && (
                <Link to={`/rsvp/${invite.event.slug}`}>
                  <Badge className="bg-warning text-dark">RSVP pending</Badge>
                </Link>
              )}
            </div>
            <h6>
              {formatDate(invite.event.start_date)}{" "}
              <AddToCalendarButton event={invite.event} />
            </h6>
            <h6 className="event-link fw-normal">
              <span className="d-sm-none">
                {invite.event.venue.split(" · ")[0]}
              </span>
              <span className="d-none d-sm-inline">{invite.event.venue}</span>{" "}
              <a
                className="text-decoration-none"
                href={invite.event.venue_link}
                rel="noreferrer"
                target="_blank"
              >
                <GeoAltFill className="align-text-top" />
              </a>
            </h6>
            <div className="fw-lighter">
              <EventDescription detailed={true} event={invite.event} />
            </div>
          </Col>
        </Row>
      ))}
    </div>
  );
};
export default Schedule;
